<template>
  <div class="tos">

    <div class="p-2 ml-2 bg-light gothic fontSizeDot9 border-top border-bottom">
      <router-link :to="{ name: 'tinkHome' }" custom v-slot="{ navigate }">
        <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
          처음
        </span>
      </router-link>
      &gt;
      <b-dropdown text="서비스 약관" size="sm" role="menu" toggle-class="pl-2 pr-2 pt-dot1 pb-dot1">
        <b-dropdown-item :to="{ name: 'tinkAbout' }">
          Tinkable 소개
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkAboutKit' }">
          IoT 키트
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkAboutCore' }">
          Core 프로그램
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkAboutData' }">
          Data 서비스
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkTos' }" :active="true">
          서비스 약관
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkPrivacy' }">
          개인정보 처리방침
        </b-dropdown-item>
      </b-dropdown>
    </div>


    <h1 class="documentTitle" v-if="!presentationMode">
      Tinkable 서비스 약관
    </h1>
    <div class="contentBody">
      <h2>개요</h2>
      <p>
        약관은 작성중에 있습니다.
      </p>
    </div>
  </div>
</template>
<script>
  import { mapState } from "vuex";
  import { mapSetter } from "@/plugins/vuexUtils.js";
  export default {
    name: "tinkTos",
    computed: {
      ...mapSetter(
        mapState({
          presentationMode:  state => state.presentationMode,
        })
      )
    },
    mounted() {
      window.document.body.scrollIntoView(true);
    },
  }
</script>
